import { Gender, IBaseUser } from "./base-user.interface";
import { Permissions } from "./permission";
import Role from "./role";

export interface IUser extends IBaseUser {
  phone: string;
  countryCode?: string;
  role: Role;
  organization?: IOrganization;
  permissions: Permissions[];
  createdAt: string;
  activatedAt: string;
  isActive: boolean;
  status: UserStatus;
  salutation?: UserTitle;
  maxProfiles?: number;
  activeProfilesCount?: number;
  totalProfiles?: number;
  lastEcgDate?: string;
  lastLoginDate?: string;
  prescribingPhysician?: {
    id: string;
    title?: string;
    firstName?: string;
    lastName?: string;
  };
  deviceSn?: string;
  totalEcgs?: number;
  beltSize?: BeltSize;
  sendReportByEmail?: boolean;
  emailVerification?: boolean;
  reference?: string;
  hasPacemaker?: boolean
}

export interface IOrganization {
  id: string;
  name: string;
  type: OrgType;
}

export interface IAddUser extends UserDetailsFormInputs {
  emailVerification?: boolean;
}

export interface IOrgDomain {
  id: number;
  domain: string;
}

export interface IUpdateUser extends Partial<UserDetailsFormInputs> {
  id: string;
}

export interface IAddPatient extends PatientDetailsFormInputs {
  password: string;
  passwordConfirmation?: string;
  isOneTimePassword?: boolean;
}

export interface IUpdatePatient extends Partial<PatientDetailsFormInputs> {
  id: string;
}

export interface ILink {
  id: string;
  to: string;
  onCLick?: () => void;
  icon?: string;
  label?: string;
}

export type UserDetailsFormInputs = {
  entity: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  email: string;
  loginName?: string;
  emailDomain?: string;
  phone?: string;
  maxProfiles?: number;
  sendActivationEmail?: boolean;
  countryCode?: string;
} & UserDetailsFormPermissions;

export type UserDetailsFormPermissions = {
  isAdmin: boolean;
  canManageProUsers: boolean;
  canLogIntoPortal: boolean;
  canViewEcgs: boolean;
  canEditInterpretation: boolean;
  canManageNonProUsers: boolean;
  canViewReports: boolean;
  canApproveEcg?: boolean;
  canViewSelfClinicsEcgs?: boolean;
  canSendEcgsViaMail?: boolean;
  canArchiveEcgs?: boolean;
};

export type PatientDetailsFormInputs = {
  entity: string;
  prescribingPhysician?: string;
  firstName: string;
  lastName?: string;
  gender?: Gender;
  dateOfBirth?: string;
  beltSize?: BeltSize;
  email: string;
  phone?: string;
  //emailVerificationRequired?: boolean;
  //sendEmails?: boolean;
  // sendReportByEmail?: boolean;
  reference?: string;
  countryCode?: string;
  canViewEcgs?: boolean,
  canSendEcgsViaMail?: boolean,
  showEcgPreview?: boolean,
  hasPacemaker?: string
};

export type UserStatus = "active" | "disabled" | "pending";

export type UserType = "professional" | "patient";

export enum UserTitle {
  Dr = "Dr.",
  Prof = "Prof.",
  None = "",
}

export type BeltSize = "S" | "M" | "L" | "XL";
export enum OrgType {
  Undefined = -1,
  Basic,
  CRO,
  EcrProvider,
  CroExtern,
  Standalone,
}
